/* TextAreaEditor.js */

"use strict";

const CommonEditor = require("./CommonEditor");

/**
 * @type {uiCoreTools}
 */
const uiCore = require("@gluenetworks/steve_ui_core");
const TextareaControl = uiCore.Control.Textfield.Textarea;

class TextAreaEditor extends CommonEditor {
    constructor(options) {
        super(options);
        this.rootElement.classList.add("textarea");
    }

    _createInput() {
        return new TextareaControl({
            darkTheme: true
        });
    }

    /*****************************/
    /*  PUBLIC API IS INHERITED  */
    /*****************************/
}

module.exports = TextAreaEditor;
